import { testimonialsData } from '@/mocks/home';

export default function TestimonialsSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            用户好评
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            来自鬼父在线用户的真实评价，您的满意是我们最大的动力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonialsData.map((item) => (
            <div key={item.name} className="p-6 rounded-xl bg-background-100">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                &ldquo;{item.comment}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <span className="text-sm font-medium text-foreground-800">{item.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}